const MODEL_VIEWER_SCRIPT_ID = "model-viewer-module";
let modelViewerLoadPromise = null;

export function loadModelViewer() {
  if (typeof window === "undefined") return Promise.resolve();
  if (window.customElements?.get("model-viewer")) return Promise.resolve();

  if (modelViewerLoadPromise) return modelViewerLoadPromise;

  const existing = document.getElementById(MODEL_VIEWER_SCRIPT_ID);
  if (existing) {
    modelViewerLoadPromise = Promise.resolve();
    return modelViewerLoadPromise;
  }

  modelViewerLoadPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.id = MODEL_VIEWER_SCRIPT_ID;
    script.type = "module";
    script.src = "https://unpkg.com/@google/model-viewer/dist/model-viewer.min.js";
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("model-viewer konnte nicht geladen werden."));
    document.head.appendChild(script);
  });

  return modelViewerLoadPromise;
}
